import { withAsyncLoading } from '../../../../../libs/IdeLink.Web.Common/src/components/withAsyncLoading';

export const AuditAnalysisPageLoading = withAsyncLoading(async () =>
    import('./AuditAnalysisPage').then(res => res.AuditAnalysisPage)
);
